import { useGetExternalDocumentCount } from '@modusign/openapi-client-external-document';

import useUsageCount from '@app/hooks/useUsageCount';
import { useWorkspaceId } from '@app/hooks/useWorkspaceId';

export default function useExternalDocumentLimit() {
  const workspaceId = useWorkspaceId();
  const limit = useUsageCount().externalDocumentCount.limit ?? 0;
  const usage = useGetExternalDocumentCount(workspaceId).data?.count ?? 0;

  const isLimitMeeted = usage === limit;
  const isLimitExceeded = usage > limit;

  return {
    limit,
    usage,
    type: (() => {
      if (isLimitMeeted) {
        return 'MEET_LIMIT' as const;
      }
      if (isLimitExceeded) {
        return 'EXCEED_LIMIT' as const;
      }
      return 'AVAILABLE' as const;
    })(),
  };
}
